import is from 'typescript-styled-is'
import styled, { ITheme } from '../../../theme'

const Label = styled.label<ILabelProps>`
  width: 100%;

  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  
  ${is('labelSpacingHorizontal')`
  padding-left: ${({ size }) => (size ? 10 * size : 10)}px;
  `}

  ${is('isCenterLabel')`
  text-align: center;
  `}

  ${is('noSpacing')`
  width: 13% !important;
  `};

  ${is('labelAutoWidth')`
    width: auto;
  `};

  font-weight: 500;
  line-height: ${({ size }) => (size ? 14 * size : 14)}px;
  user-select: none;

  margin: ${({ size }) => (size ? 10 * size : 10)}px 0px;

  ${is('smallLabelSize')`
      font-size: ${({ size }) => (size ? 12 * size : 12)}px !important;
  `};
  
  ${is(`alignInputCenter`)`
    text-align: center;
  `}

  ${is('margin')`
    margin: 0px ${({ size }) => (size ? 8 * size : 8)}px;
  `};

  ${is('bold')`
    font-weight: 600;
    color: ${({ theme }: ITheme) => theme.colors.form.label};
    font-size: ${({ size }) => (size ? `${16 * size}px` : 'unset')};
      display:flex;
      align-items: center;
  `};

  color: ${({ theme }: ITheme) => theme.colors.form.label};

  ${is('clickable')`
    cursor: pointer;
  `};

  ${is('wrapLabel')`
     word-break: break-all;
   `};

    
  ${is('labelDisabled')`
    color: ${(props: ITheme) => props.theme.colors.palette.paleGrey}
  `};


  user-select: none;
`

export default Label

export interface ILabelProps {
  horizontal?: boolean
  warning?: boolean
  error?: boolean
  size?: number
  margin?: boolean
  bold?: boolean
  disabled?: boolean
  clickable?: boolean
  wrapLabel?: boolean
  noSpacing?: boolean
  smallLabelSize?: boolean
  isCenterLabel?: boolean
  labelSpacingHorizontal?: boolean
  alignInputCenter?: boolean
  labelAutoWidth?: boolean
  labelDisabled?: boolean
}
